<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
      <span slot="button" v-if="this.isMultiple">
        <a-button type="primary" @click="multiSelectSubmit()">选择</a-button>
      </span>
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange" :rowSelection="rowSelection">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="selected(rowKey.data)">选择</a>
        </span>
      </template>
    </standard-table>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "ProductName",
          name: "产品名称"
        },
        {
          type: "input",
          key: "ProductCode",
          name: "产品编码"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 70,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 120,
          sorter: true
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          // width: 300,
          sorter: true
        },
        {
          title: "规格属性",
          width: 180,
          dataIndex: "specDes"
        },
        {
          title: "产品系列",
          dataIndex: "productSeriesName",
          width: 100
        },
        {
          title: "产品分类",
          dataIndex: "productCategoryName",
          width: 120
        },
        {
          title: "定制",
          dataIndex: "isCustom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          }
        },
        {
          title: "套件",
          dataIndex: "isBom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isBom ? "是" : "否";
          }
        },
        {
          title: "单位",
          dataIndex: "measureUnitName",
          width: 80
        },
        {
          title: "销售类型",
          dataIndex: "saleTypeName",
          width: 100
        },
        {
          title: "预计交期(天)",
          dataIndex: "expectedDelivery",
          width: 140,
          sorter: true
        }
      ],
      datas: [],
      filterdata: Object.assign(
        {
          ProductName: "",
          ProductCode: "",
          isActive: true,
          includeCustom: null
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      rowSelection: null,
      title: "",
      isMultiple: false,
      organizationId: null,
      includeCustom: null
    };
  },
  async mounted() {
    if (this.params && this.params.isMultiple) {
      this.isMultiple = true;
    }
    if (
      this.params &&
      (this.params.includeCustom == 0 || this.params.includeCustom == 1)
    ) {
      this.includeCustom = this.params.includeCustom;
    }
    if (
      this.params &&
      this.params.organizationId &&
      this.params.organizationId > 0
    ) {
      this.organizationId = this.params.organizationId;
    }
    if (this.isMultiple) {
      this.columns = this.columns.filter(a => a.dataIndex != "action");
      this.rowSelection = { onChange: this.onSelectChange };
    }
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.ProductName = p.values.ProductName;
      this.filterdata.ProductCode = p.values.ProductCode;
      this.filterdata.isActive = true;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    multiSelectSubmit() {
      this.$emit("getSelectedProduct", this.selectedRows);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRows);
      this.selectedRows = selectedRows;
      this.rowSelection = {
        selectedRows: selectedRows,
        onChange: this.onSelectChange
      };
    },
    selected(record) {
      this.$emit("getSelectedProduct", record);
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      if (this.organizationId) {
        options.organizationId = this.organizationId;
      }
      options.includeCustom = this.includeCustom;
      let data = await api.GetProductSelectList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Goods/Product/SelectProduct.vue